<template>
  <div class="header-wrap">
    <div class="container-main">
      <!--
      <el-row>
        <el-col :span="20">
          <div class="top-left">
            <div class="top-item" v-for="(v, index) in topData" :key="index">
              <div class="icon" :class="v.icon"></div>
              {{ v.text }}
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="top-right">
            <div class="top-item">
              分享
              <div class="icon top-wx"></div>
              <div class="icon top-qq"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      -->
      <el-row>
        <el-col :span="6" :xs="10">
          <router-link class="logo" :to="{ path: '/' }" tag="div">
            <img
              src="https://wp.efimotoservice.com/uploads/20210222/fdbbb9b969a3174a843ee36709508a5f.png"
              alt=""
            />
          </router-link>
        </el-col>
        <el-col class="nav-right" :span="18" :xs="14">

          
          <div class="nav-wrap nav-wrap-top hidden-xs-only">
            <div class="nav-item language" @click.stop="onLanguage">
              <span class="lang">{{
                /^zh$/.test(language) ? "en" : "zh"
              }}</span>
            </div>
            <div class="nav-item" @click="onDownLoad">
              Android {{ $t("download") }}
            </div>
          </div>




          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="white" text-color="black" active-text-color="green">
            <template  v-for="(navDataItem,navDataIndx) in _navData" >
              <template v-if="navDataItem.children==undefined" >
                <!-- 一层 -->
                <el-menu-item :index="navDataIndx+''" background-color="white" @click="onRouter(navDataItem)">{{navDataItem.text}}</el-menu-item>
              </template>


              <template v-else >

                <!-- 一层 -->
                <el-submenu :index="navDataIndx+''">
                  <template slot="title">{{navDataItem.text}}</template>
                  <template  v-for="(navDataChildItem,navDataChildIndx) in navDataItem.children" >
                    <template v-if="navDataChildItem.children==undefined" >

                      <!-- 二层 -->
                      <template v-if="navDataItem.text==productLanguage">
                        <el-menu-item :index="navDataIndx+'-'+navDataChildIndx" @click="onServiceClick(navDataChildItem,)">{{navDataChildItem.name}}</el-menu-item>
                      </template>
                      <template v-else>
                        <el-menu-item :index="navDataIndx+'-'+navDataChildIndx" @click="onServiceClick(navDataChildItem)">{{navDataChildItem.text}}</el-menu-item>
                      </template>
                      
                    </template>
                    <template v-else >

                      <!-- 二层 -->
                      <el-submenu :index="navDataIndx+'-'+navDataChildIndx" style="width:250px">
                        <template v-if="navDataItem.text==productLanguage" >
                          <template slot="title">{{navDataChildItem.name}}</template>
                        </template>
                        <template v-else>
                          <template slot="title">{{navDataChildItem.text}}</template>
                        </template>


                        <template  v-for="(navDataChildChildItem,navDataChildChildIndx) in navDataChildItem.children" >
                          <!-- 三层 -->
                          <template v-if="navDataItem.text==productLanguage" >
                            <el-menu-item style="width:250px;" :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" @click="onRouterProduct(navDataChildChildItem)">{{navDataChildChildItem.name}}</el-menu-item>
                          </template>



                          <template v-else-if="navDataItem.text==productInstructionLanguage">
                            
                            <template v-if="navDataChildItem.router=='manual'" >
                              <!-- <span>fsa</span> -->
                              <!-- <template  v-for="(navDataChildChildManualDataItem,navDataChildChildManualDataIndx) in manualData" >
                                <el-menu-item :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildManualDataIndx" background-color="white" @click="onRouterService(navDataChildChildManualDataItem, 'manual')">{{navDataChildChildManualDataItem.name}}</el-menu-item>
                              </template> -->
                              <el-menu-item style="width:250px" :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" @click="onRouterService(navDataChildChildItem, 'manual')">{{navDataChildChildItem.name}}</el-menu-item>
                            </template>
                            <template v-else-if="navDataChildItem.router=='video'" >
                              <!-- <template  v-for="(navDataChildChildVideoDataItem,navDataChildChildVideoDataIndx) in videoData" >
                                <el-menu-item :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildVideoDataIndx" background-color="white" @click="onRouterService(navDataChildChildVideoDataItem, 'video')">{{navDataChildChildVideoDataItem.name}}</el-menu-item>
                              </template> -->
                              <el-menu-item style="width:250px" :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" @click="onRouterService(navDataChildChildItem, 'video')">{{navDataChildChildItem.name}}</el-menu-item>
                            </template>
                            <template v-else-if="navDataChildItem.router=='synopsis'" >
                              <el-menu-item style="width:250px" :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" @click="onRouterService(navDataChildChildItem, 'synopsis')">{{navDataChildChildItem.name}}</el-menu-item>
                            </template>
                            <template v-else >
                              <el-menu-item style="width:250px" :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" >{{navDataChildChildItem.name}}</el-menu-item>
                            </template>

                          
                          
                          
                          </template>



                          <template v-else>
                            <el-menu-item :index="navDataIndx+'-'+navDataChildIndx+'-'+navDataChildChildIndx" background-color="white" >{{navDataChildChildItem.text}}</el-menu-item>
                          </template>



                          
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                 

                </el-submenu>
              </template>
            </template >
          
          </el-menu>

          <div class="nav-wrap hidden-xs-only" v-show="false">
            <div class="nav-item" :class="v.router" v-for="(v, index) in _navData" :key="index" @click.stop="onRouter(v)" >
              <div class="img" v-if="v.router === 'user' && isLogin">
                <!-- <img :src="anselmUserInfo.avatar" alt="" /> -->
              </div>
              <span :class="[{ active: $route.name === v.router }, v.router]">
                {{ v.text }}
                <i class="el-icon-caret-bottom" v-if="/^(product|service)$/gi.test(v.router)"></i>
              </span>

              <div @mousemove="() => {return false;}" :class="[{ active: $route.name === v.router }, 'nav-second']" v-if="/^(product|service)$/.test(v.router)">
                <div class="nav-second-item" v-if="v.children && /^(service)$/.test(v.router)">
                  <div class="second-item-text" v-for="vv in v.children" :key="vv.text" @click.stop="onServiceClick(vv)" @mouseenter.stop="onServiceMouseEnter(vv)">
                    {{ vv.text+123 }}
                    <div class="second-children" v-if="/^(video)$/.test(vv.router) && isVideo">
                      <div class="second-children-item" v-for="vvv in videoData" :key="vvv.name">
                        <div class="name" @click.stop="onRouterService(vvv, 'video')">
                          {{ vvv.name }}
                          <div class="second-children">
                            <div  class="second-children-item"  v-for="vvvv in vvv.children"  :key="vvvv.name">
                              <div class="name"  @click.stop="onRouterService(vvvv, 'video')">
                                {{ vvvv.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="second-children"  v-if="/^(manual)$/.test(vv.router) && !isVideo">
                      <div  class="second-children-item"  v-for="vvv in manualData"  :key="vvv.name"  >
                        <div  class="name"  @click.stop="onRouterService(vvv, 'manual')"  >
                          {{ vvv.name }}
                          <div class="second-children">
                            <div class="second-children-item"  v-for="vvvv in vvv.children"  :key="vvvv.name">
                              <div  class="name"  @click.stop="onRouterService(vvvv, 'manual')">
                                {{ vvvv.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div  class="second-children"  v-if="/^(synopsis)$/.test(vv.router)"  >
                      <div  class="second-children-item"  v-for="vvv in synopsisData"  :key="vvv.name"  >
                        <div  class="name"  @click.stop="onRouterService(vvv, 'synopsis')">
                          {{ vvv.name }}
                          <div class="second-children">
                            <div  class="second-children-item"  v-for="vvvv in vvv.children"  :key="vvvv.name">
                              <div  class="name"  @click.stop="onRouterService(vvvv, 'video')">
                                {{ vvvv.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div  class="nav-second-item"  v-if="productData.length && /^(product)$/.test(v.router)">
                  <div  class="second-item-text"  v-for="(vv, index) in productData"  :key="vv.name"  :class="{ active: currentIndex === index }">
                    {{ vv.name }}
                    <div class="second-children">
                      <div  class="second-children-item"  v-for="vvv in vv.children"  :key="vvv.text"  @click.stop="onRouterProduct(vvv)">
                        <div  class="name"  :class="{ active: $route.query.cat == vvv.id }">
                          {{ vvv.name }}
                          <div class="second-children">
                            <div  class="second-children-item"  v-for="vvvv in vvv.children"  :key="vvvv.name">
                              <div  class="name"  @click.stop="onRouterProduct(vvvv)">
                                {{ vvvv.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        

          <div class="nav-menu hidden-sm-and-up">
            <el-menu class="nav-menu-wrap" v-if="isMenu">
              <div class="close" @click="onMenu">
                <span class="el-icon-close" />
              </div>

              <div v-for="(v, index) in _navData" :key="index">
                <el-submenu  v-if="v.children !== undefined"  :index="`${Number(index)}`"  @click="onRouter(v, true)">
                  <template slot="title">
                    <div class="menu-nav-item-wrap">
                      <div class="menu-nav-item" :class="v.router">
                        <div class="img" v-if="v.router === 'user' && isLogin">
                          <img :src="anselmUserInfo.avatar" alt="" />
                        </div>
                        {{ v.text }}
                      </div>
                    </div>
                  </template>
                  <template v-if="/^(product)$/.test(v.router)">
                    <template v-for="(vv, vvindex) in productData">
                      <el-submenu  v-if="vv.name !== undefined"  :key="vv.name"  :index="`${Number(index)}-${Number(vvindex)}`">
                        <template slot="title">
                          <div class="menu-nav-item-wrap">
                            <div class="menu-nav-item"  @click.stop="onRouterProduct(vv)">
                              {{ vv.name }}
                            </div>
                          </div>
                        </template>
                        <template v-if="vv.children.length">
                          <el-menu-item  v-for="(vvv, vvvindex) in vv.children"  :key="vvv.name"  :index="`${Number(index)}-${Number(vvvindex)}`">
                            <template slot="title">
                              <div class="menu-nav-item-wrap">
                                <div  class="menu-nav-item"  @click.stop="onRouterProduct(vvv)">
                                  {{ vvv.name }}
                                </div>
                              </div>
                            </template>
                          </el-menu-item>
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                  <template v-if="/^(service)$/.test(v.router)">
                    <template v-for="(vv, vvindex) in v.children">
                      <el-submenu  v-if="/^(manual|video|synopsis)$/.test(vv.router)"  :key="vv.text"  :index="`${Number(index) + 1}-${Number(vvindex)}`">
                        <template slot="title">
                          <div class="menu-nav-item-wrap">
                            <div class="menu-nav-item">
                              {{ vv.text }}
                            </div>
                          </div>
                        </template>
                        <template v-if="/^(manual)$/.test(vv.router)">
                          <el-submenu  v-for="(vvv, vvvindex) in manualData"  :key="vvv.name"  :index="  `${Number(index) + 1 * 10}-${Number(vvvindex) +  1}`  ">
                            <template slot="title">
                              <div class="menu-nav-item-wrap">
                                <div  class="menu-nav-item"  @click.stop="onRouterService(vvv, 'manual')">
                                  {{ vvv.name }}
                                </div>
                              </div>
                            </template>
                            <template  v-if="  vvv.hasOwnProperty('children') &&  vvv.children.length  ">
                              <el-menu-item  v-for="(vvvv, vvvvindex) in vvv.children"  :key="vvvv.name"  :index="  `${Number(index) + 1}-${Number(vvvvindex) +  1}`  ">
                                <template slot="title">
                                  <div class="menu-nav-item-wrap">
                                    <div  class="menu-nav-item"  @click.stop="  onRouterService(vvvv, 'manual')  ">
                                      {{ vvvv.name }}
                                    </div>
                                  </div>
                                </template>
                              </el-menu-item>
                            </template>
                          </el-submenu>
                        </template>
                        <template v-if="/^(video)$/.test(vv.router)">
                          <el-submenu  v-for="(vvv, vvvindex) in videoData"  :key="vvv.name"  :index="`${Number(index)}-${Number(vvvindex)}`">
                            <template slot="title">
                              <div class="menu-nav-item-wrap">
                                <div  class="menu-nav-item"  @click.stop="onRouterService(vvv, 'video')">
                                  {{ vvv.name }}
                                </div>
                              </div>
                            </template>
                            <template v-if="  vvv.hasOwnProperty('children') &&  vvv.children.length  ">
                              <el-menu-item  v-for="(vvvv, vvvvindex) in vvv.children"  :key="vvvv.name"  :index="`${Number(index)}-${Number(vvvvindex)}`">
                                <template slot="title">
                                  <div class="menu-nav-item-wrap">
                                    <div  class="menu-nav-item"  @click.stop="  onRouterService(vvvv, 'video')  ">
                                      {{ vvvv.name }}
                                    </div>
                                  </div>
                                </template>
                              </el-menu-item>
                            </template>
                          </el-submenu>
                        </template>
                        <template v-if="/^(synopsis)$/.test(vv.router)">
                          <el-submenu v-for="(vvv, vvvindex) in synopsisData" :key="vvv.name" :index=" `${Number(index) + 1 * 10}-${Number(vvvindex) + 1}` ">
                            <template slot="title">
                              <div class="menu-nav-item-wrap">
                                <div  class="menu-nav-item"  @click.stop="onRouterService(vvv, 'synopsis')">
                                  {{ vvv.name }}
                                </div>
                              </div>
                            </template>
                            <template  v-if="  vvv.hasOwnProperty('children') &&  vvv.children.length  ">
                              <el-menu-item v-for="(vvvv, vvvvindex) in vvv.children"  :key="vvvv.name"  :index=" `${Number(index) + 1}-${Number(vvvvindex) +  1}`  ">
                                <template slot="title">
                                  <div class="menu-nav-item-wrap">
                                    <div  class="menu-nav-item"  @click.stop="  onRouterService(vvvv, 'synopsis')  ">
                                      {{ vvvv.name }}
                                    </div>
                                  </div>
                                </template>
                              </el-menu-item>
                            </template>
                          </el-submenu>
                        </template>
                      </el-submenu>
                      <el-menu-item v-else :key="vv.text" :index="`${Number(index) + 1}-${Number(vvindex)}`" @click="onServiceClick(vv)">
                        <template slot="title">
                          <div class="menu-nav-item-wrap">
                            <div class="menu-nav-item">
                              {{ vv.text+12 }}
                            </div>
                          </div>
                        </template>
                      </el-menu-item>
                    </template>
                  </template>
                </el-submenu>
                <el-menu-item class="menu-nav-item-wrap" v-else>
                  <div  class="menu-nav-item"  :class="v.router"  :index="`${Number(index) + 1}`"  @click="onRouter(v, true)">
                    <div class="img" v-if="v.router === 'user' && isLogin">
                      <img :src="anselmUserInfo.avatar" alt="" />
                    </div>

                    <span slot="title">{{ v.text }}</span>
                  </div>
                </el-menu-item>
              </div>
            </el-menu>
            <div class="icon-menu" @click="onMenu" v-else>
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>

          
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import LStore from "store";
import API from "@/api";

export default {
  data() {
    return {
      productLanguage: '',
      productInstructionLanguage: '',
      activeIndex: '0',
      activeIndex2: '1',
      newlistProductData:[],


      isMenu: false,
      topData: [
        {
          icon: "top-tel",
          text: "0755-88888888"
        },
        {
          icon: "top-mail",
          text: "support@mast.com"
        },
        {
          icon: "top-clock",
          text: "7X24小时优质服务"
        }
      ],
      navData: [
        {
          value: "",
          router: "/",
          text: this.$t("home")
        },
        {
          value: "",
          router: "news",
          text: this.$t("news")
        },
        {
          value: "",
          router: "product",
          text: this.$t("product"),
          children: []
        },
        {
          value: "",
          router: "service",
          text: this.$t("support"),
          children: [
            {
              value: "",
              router: "service",
              text: this.$t("guide")
            },
            {
              value: "",
              router: "manual",
              text: this.$t("manual")
            },
            {
              value: "",
              router: "video",
              text: this.$t("video")
            },
            {
              value: "",
              router: "synopsis",
              text: this.$t("synopsis")
            }
          ]
        },
        {
          value: "",
          router: "soft",
          text: this.$t("upgrade")
        },
        {
          value: "",
          router: "about",
          text: this.$t("about")
        },
        {
          value: "",
          router: "feedback",
          text: this.$t("feedback")
        },
        {
          value: "",
          router: "login",
          text: this.$t("login") + "/" + this.$t("register")
        }
      ],
      currentIndex: -1,
      isVideo: false
    };
  },
  computed: {
    ...mapState([
      "isLogin",
      "anselmUserInfo",
      "productData",
      "manualData",
      "videoData",
      "synopsisData",
      "language",
      "aboutContact"
    ]),
    _navData() {
      return this.isLogin
        ? this.navData.slice(0, -1).concat([
            {
              value: "",
              router: "user",
              text: this.$t("personal")
            },
            {
              value: "",
              router: "logout",
              text: this.$t("layout")
            }
          ])
        : this.navData;
    }

  },


  watch:{
    // productData:function(newV,oldV){
    //         console.log(newV); 
    //         console.log(oldV);
    //         let newProduct = {
    //           value: "",
    //           router: "product",
    //           text: this.$t("product"),
    //           children: []
    //         }
    //     this.$set(newProduct, "children", newV);
    //     this.navData.splice(2,1,newProduct) 
    //     console.log("watchproductData")
    //     }
  },

  created() {
    
    this.initMenu()
    this.activeIndex = LStore.get("defaultSelectMenu")
    // LStore.set("language", "en");
    // console.log(LStore.get("language"))
    // if(LStore.get("language") == 'zh'){
    //   this.aboutContact.image = 'https://wp.efimotoservice.com/' + this.aboutContact.image
    // }
    // console.log(this.aboutContact)
    // console.log(this.defaultSelectMenu)

  },
  onload() {

  },
  updated(){
    console.log(this.defaultSelectMenu)
         
        this.$set(this.navData[3].children[1], "children", this.manualData);
        this.$set(this.navData[3].children[2], "children", this.videoData);
        this.$set(this.navData[3].children[3], "children", this.synopsisData);
        this.$set(this.navData[2], "children", this.productData);
  },
  // afterUpdated(){

  // },
  methods: {
    ...mapMutations([
      "USER_INFO",
      "IS_LOGIN",
      "MANUAL_DATA",
      "VIDEO_DATA",
      "DEFAULT_SELECT_MENU",
      "SYNOPSIS_DATA",
      "LANGUAGE"
    ]),

    handleSelect(key, keyPath) {
      this.DEFAULT_SELECT_MENU(keyPath[0]);
      LStore.set("defaultSelectMenu", keyPath[0]);
    },

    async initMenu(){
      console.log("initMenu")
      const method1 = this.motomanualCat();
      const method2 = this.motovideoCat();
      const method3 = this.synopsisCat();
      try{
        await Promise.all([method1,method2,method3])
        this.productLanguage = this.$t("product")
        this.productInstructionLanguage = this.$t("support")
        // ===========================================
        // let newProduct = {
        //   value: "",
        //   router: "product",
        //   text: this.$t("product"),
        //   children: []
        // }
        // console.log(this.productData)
        // this.$set(newProduct, "children", this.productData);
        // this.navData.splice(2,1,newProduct) 
        // ===========================================
      }catch(error){
        console.log(error)
      }
    },

    motomanualCat(params) {
      API.motomanualCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.MANUAL_DATA(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    motovideoCat(params) {
      API.motovideoCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.VIDEO_DATA(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    synopsisCat(params) {
      API.synopsisCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.SYNOPSIS_DATA(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    logout(params) {
      API.logout(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.IS_LOGIN(false);
          this.USER_INFO(null);
          LStore.remove("anselmUserInfo");
          this.$router.push({ path: "/" });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onRouter(v, isShow) {
      console.log("onRouter")
      console.log(v)
      console.log(isShow)
      if (/^logout$/.test(v.router)) {
        this.logout({
          token: this.anselmUserInfo.token
        });
        return false;
      }
      if (isShow) {
        this.$set(this, "isMenu", !this.isMenu);
      }
      if (this.$route.name === v.router) return;
      if (/^(product|service)$/.test(v.router)) return;
      if (this.anselmUserInfo === null && /^(soft)$/.test(v.router)) {
        this.$message.success(this.$t("tipsLogin"));
        return false;
      }
      this.$router.push({
        path: v.router
      });
    },
    onMenu() {
      this.$set(this, "isMenu", !this.isMenu);
    },
    onMenuRouter(v) {
      this.$router.push({
        path: v
      });
    },
    onRouterProduct(v) {
      console.log("onRouterProduct")
      console.log(v)
      this.$set(this, "isMenu", false);
      if (Number(this.$route.query.cat) === Number(v.id)) return;
      this.$router.push({
        path: "product",
        query: {
          cat: v.id
        }
      });
      this.$emit("on-product", v);
    },
    onRouterService(v, type) {
      this.$set(this, "isMenu", false);
      console.log("onRouterService")
      console.log(v)
      console.log(type)
      if (this.onUserSNCount()) return;
      if (Number(this.$route.query.cat) === Number(v.id)) return;
      this.$router.push({
        path: type,
        query: {
          cat: v.id
        }
      });
      this.$emit("on-service", v);
    },
    onMouseenterSecond() {
      // e.currentTarget.firstElementChild.style.display = "block";
      // console.log(e.currentTarget.firstElementChild);
    },
    onMouseleaveSecond() {},
    onLanguage() {
      if (/^zh$/.test(this.language)) {
        LStore.set("language", "en");
        this.LANGUAGE("en");
      } else {
        LStore.set("language", "zh");
        this.LANGUAGE("zh");
      }
      // console.log(this.productData)
      this.$router.go(0);
    },
    onServiceMouseEnter(v) {
      if (/^video$/.test(v.router)) {
        this.$set(this, "isVideo", true);
      } else {
        this.$set(this, "isVideo", false);
      }
    },
    onServiceClick(v) {
      console.log("onServiceClick")
      console.log(v)
      this.$set(this, "isMenu", false);
      if (this.onUserSNCount()) return;
      if (/^(service)$/.test(this.$route.name)) return;
      if (/^service$/.test(v.router)) {
        this.$router.push({
          path: v.router
        });
      }
    },
    onUserSNCount() {
      let v = false;
      if (this.anselmUserInfo === null) {
        this.$message.success(this.$t("tipsLogin"));
        v = true;
      } else if (Number(this.anselmUserInfo.userSNCount) <= 0) {
        this.$message.success(this.$t("tipsSn"));
        v = true;
      }
      return v;
    },
    onDownLoad() {
      window.open(this.aboutContact.androidpath);
    }
  }
};
</script>

<style lang="less" scoped>

// 
/deep/.el-menu .el-menu-item:hover{
    outline: 0 !important;
    // 
    background-color: #59ac6a !important;
    background-color: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}
// 
/deep/.el-menu .el-menu-item.is-active {
    color: #59ac6a !important;
    background: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}
.el-menu .el-menu-item:hover {
  // color: #59ac6a !important;
  background-color: #59ac6a !important;
  background-color: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}
// 
.el-submenu /deep/.el-submenu__title:hover {
  background-color: #59ac6a !important;
  background-color: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}



// .el-menu .el-menu-item.is-active {
//       background-color: #59ac6a !important;
//       color: #fff;
//       span {
//         color: #fff !important;
//       }
//     }
// .el-submenu.is-active > .el-menu {
//   background-color: #59ac6a; 
// }

.header-wrap {
  position: sticky;
  top: 0;
  height: 136px;
  border-bottom: 5px solid var(--color-green);
  background: var(--color-white);
  z-index: 999;

  .top-left {
    display: flex;
    height: 30px;
    align-items: center;
    font-size: 12px;
    color: var(--color-light-black);

    .top-item {
      margin-right: 20px;

      .icon {
        position: relative;
        top: 3px;
        display: inline-block;
        width: 18px;
        height: 18px;

        &.top-tel {
          background: url("~@a/img/top-tel.png") no-repeat;
          background-size: 100% 100%;
        }

        &.top-mail {
          height: 14px;
          background: url("~@a/img/top-mail.png") no-repeat;
          background-size: 100% 100%;
        }

        &.top-clock {
          background: url("~@a/img/top-clock.png") no-repeat;
          background-size: 100% 100%;
        }

        &.top-wx {
          background: url("~@a/img/top-wx.png") no-repeat;
          background-size: 100% 100%;
        }

        &.top-qq {
          background: url("~@a/img/top-qq.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .top-right {
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px;
    color: var(--color-light-black);
    .top-item {
      margin-right: 5px;

      .icon {
        position: relative;
        top: 3px;
        display: inline-block;
        width: 18px;
        height: 18px;

        &.top-wx {
          background: url("~@a/img/top-wx.png") no-repeat;
          background-size: 100% 100%;
          margin: 0 5px;
        }

        &.top-qq {
          background: url("~@a/img/top-qq.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .logo {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 15px;
    padding-right: 20px;
    border-right: 1px solid #ccc;
  }

  .nav-wrap {
    height: 40px;
    display: flex;
    align-items: center;

    .language {
      text-transform: uppercase;

      .lang {
        padding: 2px;
        border-radius: 2px;
        border: 1px solid var(--color-line-black);
      }
    }

    .nav-item {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
      color: var(--color-black);
      cursor: pointer;

      &:hover {
        .nav-second {
          display: flex;
          opacity: 1;
          transition: 0.5s all;
        }
        i {
          transform: rotateZ(180deg);
          transition: 0.3s all;
        }
      }

      &.user {
        span {
          position: relative;
          top: -9px;
          margin-left: 5px;
        }
      }

      span {
        display: inline-block;

        &.active {
          position: relative;

          // &:hover {
          //   i {
          //     transform: rotateZ(180deg);
          //     transition: 0.3s all;
          //   }
          // }

          &::after {
            position: absolute;
            left: 5px;
            right: 5px;
            top: 25px;
            display: inline-block;
            content: "";
            height: 4px;
            background: var(--color-green);
            border-radius: 5px;
          }
        }
      }
    }

    &.nav-wrap-top {
      margin-top: 20px;
      .nav-item {
        font-size: 14px;
        font-weight: initial;
      }
    }
  }

  .nav-menu {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: flex-end;
    margin-right: 5px;

    .icon-menu {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: var(--color-black);
      flex-direction: column;

      .line {
        width: 50%;
        height: 4px;
        background: var(--color-grey);
        border-radius: 5px;
        &:not(:last-child) {
          margin-bottom: 2px;
        }
      }
    }
  }

  .nav-menu-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.9);

    .close {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: var(--color-grey);
      padding: 10px 20px;
      font-size: 30px;
    }

    .menu-nav-item-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: var(--color-white);
      font-size: 18px;

      .menu-nav-item {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }
}
.nav-second {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  // top: 135px;
  left: 0;
  right: 0;
  z-index: 9999;
  border-bottom: 1px solid var(--color-line-light);
  box-shadow: 1px 0 0 0 var(--color-line-light-grey);
  // opacity: 0;
  // overflow-x: scroll;
  // overflow-y: hidden;
  white-space: nowrap;
  padding-top: 48px;
  // border-top: 5px solid var(--color-green);

  // &.active {
  //   opacity: 1;
  //   transition: 0.5s all;
  // }

  .nav-second-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(245, 245, 245);

    .second-item-text {
      padding: 20px;

      &.active,
      &:hover {
        background: var(--color-green);
        color: var(--color-white);
      }
      &:hover {
        .second-children {
          opacity: 1;
          transition: 0.5s all;
          display: block;
        }
      }

      .second-children {
        display: none;
        opacity: 0;
        position: absolute;
        left: 0;
        right: 0;
        margin-top: 20px;
        color: var(--color-grey-black);

        .second-children-item {
          .name {
            position: relative;
            display: inline-block;
            min-width: 350px;
            padding: 20px;
            background: rgb(245, 245, 245);

            .second-children {
              display: none;
              opacity: 0;
              left: 350px;
              bottom: 0;
            }

            &.active,
            &:hover {
              background: var(--color-green);
              color: var(--color-white);

              .second-children {
                display: flex;
                opacity: 1;
                transition: 0.3s all;
              }
            }
          }
        }
      }
    }
  }
}
.img {
  display: inline-block;
  width: 0;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}

@media only screen and (max-width: 767px) {
  .header-wrap {
    height: 100px;
    .top-left {
      .top-item {
        margin-right: 0px;
        margin-left: 5px;

        .icon {
          top: 0;
          width: 10px;
          height: 10px;
          &.top-mail {
            height: 10px;
          }
        }
      }
    }

    .top-right {
      .top-item {
        .icon {
          top: 0;
          width: 12px;
          height: 12px;
        }
      }
    }

    .logo,
    .nav-wrap {
      height: 60px;
    }

    .logo {
      margin-left: 5px;

      padding-right: 0;
      border-right: 0;
    }
  }
}
</style>
